import axios from '~/services/axios';
import BaseClient from './BaseClient';

class GroupImportsClient extends BaseClient {
    list(teamId, groupId, importType, params) {
        return this.makeCoreApiRequest(
            `${this.apiBase}/teams/${teamId}/groups/${groupId}/imports/${importType}`,
            'GET',
            null,
            params
        );
    }

    listErrors(teamId, groupId, importType, importId, params) {
        return this.makeCoreApiRequest(
            `${this.apiBase}/teams/${teamId}/groups/${groupId}/imports/${importType}/${importId}/errors`,
            'GET',
            null,
            params
        );
    }

    generateContactsImportUploadUrl(teamId, groupId, fileName, tags) {
        const url = `/api/v3/teams/${teamId}/groups/${groupId}/contacts/upload-urls`;

        return this.makeCoreApiRequest(url, 'post', {
            original_file_name: fileName,
            tags: tags,
        });
    }

    importContactsCsvFile(preSignedS3Url, file) {
        return axios.put(preSignedS3Url, file, {
            headers: {
                'Content-Type': 'text/csv',
            },
        });
    }
}

export default new GroupImportsClient({
    apiBase: window.Spark.apiBase,
});
